<script>
import StandardV2BannerCarousel from "@/components/profile/StandardV2BannerCarousel.vue";

export default {
  name: "BanobagiBannerCarousel",
  components: {
    StandardV2BannerCarousel
  },
  inheritAttrs: false,
  props: {
    bannerList: {
      type: Array,
      default: null
    },
    profile: {
      type: Object,
      default: () => ({})
    },
    dataTestPrefix: {
      type: String,
      default: "profile-banner-carousel"
    }
  }
};
</script>

<template>
  <div class="banobagi-banner">
    <StandardV2BannerCarousel
      v-bind="$attrs"
      :banner-list="bannerList"
      :profile="profile"
      :data-test-prefix="dataTestPrefix"
    />
  </div>
</template>

<style lang="scss" scoped>
.banobagi-banner {
  position: relative;
  z-index: 1;
  overflow: hidden;
  // border-radius: 0 0 30px 30px;
  // background: linear-gradient(135deg, #ffd7a9 0%, #ff9e91 100%);
  box-shadow: 0 18px 38px rgba(127, 73, 106, 0.14);
}

.banobagi-banner :deep(.banner-carousel-v2) {
  margin: 0;
  padding: 0;
}

.banobagi-banner :deep(.banner-carousel-v2__media),
.banobagi-banner :deep(.banner-carousel-v2__image-button) {
  min-height: 210px;
  border-radius: 0 0 30px 30px;
}

.banobagi-banner :deep(.banner-carousel-v2__media),
.banobagi-banner :deep(.banner-carousel-v2__image .v-img__img) {
  object-fit: cover;
}

.banobagi-banner :deep(.swiper-pagination) {
  bottom: 12px;
  z-index: 2;
}

.banobagi-banner :deep(.swiper-pagination-bullet) {
  background: rgba(255, 255, 255, 0.72);
}

.banobagi-banner :deep(.swiper-pagination-bullet-active) {
  background: var(--primary-color);
}

@media (max-width: 360px) {
  .banobagi-banner :deep(.banner-carousel-v2__media),
  .banobagi-banner :deep(.banner-carousel-v2__image-button) {
    min-height: 184px;
  }
}
</style>
